
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.948 1a.76.76 0 01.54.224c.415.43.724.95.902 1.52l.869.474a3.895 3.895 0 011.765-.06c.2.038.375.16.481.334l1.1 1.8c.104.174.13.384.072.579a3.835 3.835 0 01-.868 1.54l.022.99c.425.42.746.934.937 1.5a.724.724 0 01-.052.585l-1.013 1.85a.724.724 0 01-.462.356 3.82 3.82 0 01-1.77.02l-.844.514a3.827 3.827 0 01-.832 1.563.724.724 0 01-.528.248l-2.11.049h-.016a.724.724 0 01-.524-.225 3.843 3.843 0 01-.902-1.519l-.868-.475a3.84 3.84 0 01-1.768.06.724.724 0 01-.48-.334l-1.096-1.801a.724.724 0 01-.073-.58 3.835 3.835 0 01.868-1.54l-.022-.99a3.835 3.835 0 01-.936-1.5.724.724 0 01.049-.583l1.013-1.85a.724.724 0 01.464-.356 3.84 3.84 0 011.768-.02l.844-.514a3.844 3.844 0 01.833-1.562.724.724 0 01.528-.249zm-.312 1.454l-1.42.032a2.17 2.17 0 00-.315.614.724.724 0 01-.329.785l-1.53.93a.724.724 0 01-.848-.071 2.234 2.234 0 00-.69 0l-.681 1.244c.094.212.22.407.375.579.3.09.508.364.515.677l.041 1.79a.724.724 0 01-.483.699 2.2 2.2 0 00-.347.598l.738 1.212c.23.025.462.013.69-.034a.724.724 0 01.842-.107l1.572.86c.275.15.42.46.362.768.082.216.198.418.343.599l1.42-.033c.136-.187.243-.394.315-.614a.724.724 0 01.328-.785l1.53-.932a.724.724 0 01.848.073c.229.036.462.036.69 0l.681-1.244a2.21 2.21 0 00-.373-.579.724.724 0 01-.516-.677l-.041-1.791a.724.724 0 01.484-.699 2.2 2.2 0 00.346-.597l-.738-1.212a2.187 2.187 0 00-.69.032.724.724 0 01-.842.109L9.34 3.82a.724.724 0 01-.362-.769 2.211 2.211 0 00-.343-.597zM6.426 6.02A2.605 2.605 0 019.3 5.757a2.603 2.603 0 011.037 3.534 2.605 2.605 0 01-4.78-.517 2.605 2.605 0 01.867-2.754zm2.18 1.006a1.153 1.153 0 10-1.102 2.025 1.153 1.153 0 001.102-2.025z"}})])
          )
        }
      }
    